import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	divider: {
		margin: "0 8px",
		color: "#6D7482",
	},
	[`@media (max-width: ${theme.media.md})`]: {
		divider: {
			margin: "0 4px",
		},
	},
}));

const Bull = () => {
	const classes = useStyles();

	return <span className={classes.divider}>&bull;</span>;
};

export default Bull;
